
import axios from "axios"
import Vue from "vue"
import Webcam from "@/components/Webcam.vue"

export default Vue.extend({
  name: "MultipleUploadCard",
  components: {
    Webcam
  },
  props: {
    name: String,
    files: Array,
    kiosk: {
      default: false,
      type: Boolean
    },
    facingMode: {
      type: String,
      default: 'environment',
      validator(value: string) {
        return ['user', 'environment'].includes(value)
      }
    }
  },
  data: () => ({
    file: null as null | Blob | File,
    loading: false,
    icon: "mdi-plus-thick",
    uploading: false
  }),
  methods: {
    uploadSnapshot(ref: string, snapshot: Blob) {
      this.file = snapshot
      this.uploadFile(ref)
    },
    uploadFile(ref: string) {
      if (this.file && this.file.size <= 8388608) {
        this.loading = true
        this.uploading = true // spinner
        let formData = new FormData()
        // file
        formData.append("files[]", this.file)
        axios
          .post("/uploads", formData)
          .then((response) => {
            this.loading = false
            this.$emit("uploadFile", ref, response.data.success[0])
          })
          .catch((error) => {
            this.loading = false
            this.emitError(
              this.$vuetify.lang.t("$vuetify.api_errors." + error.response.status)
            )
          }).finally(() => {
            this.uploading = false // spinner
          })
      } else {
        this.emitError(
          this.$vuetify.lang.t(
            "$vuetify.subscription_page.non_compliant_file_error"
          )
        )
      }
    },
    emitError(message: string) {
      this.$emit("emitError", message)
    },
    selectFile(ref: string) {
      if (this.kiosk) {
        const webcamInput = (this.$refs[ref] as Vue & { openWebcam(): (() => void) }[])[0]
        webcamInput.openWebcam()
      } else {
        const fileInput = this.$refs[ref] as Vue & {
          $refs: {
            input: HTMLElement
          }
        }[]
        fileInput[0].$refs.input.click()
      }
    },
  },
})
